export default __webpack_public_path__ + "static/media/Capture.ef778fb0.PNG";